export class overlayHtml{
  public overlay;

  constructor(public id, protected html?) {}

  public createOverlay(isModel?){
    this.overlay = document.createElement('div');
    this.overlay.setAttribute('id', this.id);
    this.overlay.setAttribute('is_model', isModel);
    // this.overlay.setAttribute('draggable', false);
    if (this.html){
      this.overlay.innerHTML = this.html;
    }
    let img = this.overlay.querySelector('img');
    if (img){
      img.setAttribute('draggable', false);
    }
  }

  protected setOverlayStyles(stylesStr){
    if (!stylesStr){
      return;
    }

    let topLeftDisplay = {top: this.overlay.style.top, left: this.overlay.style.left, display: this.overlay.style.display};
    this.overlay.style.cssText = '';
    if (typeof stylesStr == 'string'){
      this.overlay.style.cssText = `top: ${topLeftDisplay.top}px; left: ${topLeftDisplay.left}px; display: ${topLeftDisplay.display};  ${stylesStr}`;
    }
    else if (typeof stylesStr == 'object') {
      Object.assign(this.overlay.style, topLeftDisplay, stylesStr);
    }
  }
}
